import type { ARModelData } from "@core/content/types";

const CREATOR_PANELS_URL = "https://launch.eyejack.io/Artwork-64f96598-c406-4300-913b-ae8300181b14/json";

export const ContentData: ARModelData[] = [
  {
    id: "abolitionist-place",
    type: "scene",
    name: "Abolitionist Place",
    displayName: "Abolitionist Place",
    displaySubtitle: "AR Experience",
    arType: "webxr",
    content: [
      {
        type: "panels",
        path: CREATOR_PANELS_URL,
      },
    ],
  },
];
